"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.daysRemaining = daysRemaining;
exports.clockStatusForDeadline = clockStatusForDeadline;
// Read-time derivation shared by the resolver and UI copy — kept separate
// from computeContainerClock so callers can re-derive status from a stored
// deadline without re-running the whole rule engine.
const types_1 = require("./rules/types");
const MS_PER_DAY = 24 * 60 * 60 * 1000;
function utcMidnightMs(date) {
    return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}
// Whole UTC days between the two dates' midnights (positive when the
// deadline is in the future). Exact at UTC midnight boundaries.
function daysRemaining(deadline, now) {
    return Math.round((utcMidnightMs(deadline) - utcMidnightMs(now)) / MS_PER_DAY);
}
function clockStatusForDeadline(deadline, now, approachingWindowDays = types_1.APPROACHING_WINDOW_DAYS) {
    if (deadline === null) {
        return "NONE";
    }
    const remaining = daysRemaining(deadline, now);
    if (remaining < 0) {
        return "OVERDUE";
    }
    if (remaining <= approachingWindowDays) {
        return "APPROACHING";
    }
    return "OK";
}
//# sourceMappingURL=clockStatus.js.map